export interface AccountContact {
  name: string;
  phone?: string;
  email: string;
  serviceTitle: string;
  programID: number;
  published: boolean;
  isInactive: boolean;
  inactiveReason: string;
}

export class AccountContactRow {
  roles: string[] = [];
  contacts: AccountContact[] = [];
  expanded = false;
}

export interface ProgramContact {
  programID: number;
  programName?: string;
  contacts: AccountContactRow[];
  expanded?: boolean;
}
